var map = {
	"./Portrait.svg": 6295,
	"./Template1.svg": 913,
	"./Template2.svg": 7778,
	"./Template3.svg": 2419,
	"./Template4.svg": 2236,
	"./template_brand_promoter.png": 9683,
	"./template_business_owners.png": 2642,
	"./template_general_practitioner.png": 384,
	"./template_landscape.png": 3972,
	"./template_light.png": 367,
	"./template_simple.png": 4869,
	"./tick.svg": 7801,
	"assets/templates/Portrait.svg": 6295,
	"assets/templates/Template1.svg": 913,
	"assets/templates/Template2.svg": 7778,
	"assets/templates/Template3.svg": 2419,
	"assets/templates/Template4.svg": 2236,
	"assets/templates/template_brand_promoter.png": 9683,
	"assets/templates/template_business_owners.png": 2642,
	"assets/templates/template_general_practitioner.png": 384,
	"assets/templates/template_landscape.png": 3972,
	"assets/templates/template_light.png": 367,
	"assets/templates/template_simple.png": 4869,
	"assets/templates/tick.svg": 7801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2075;